import { Link } from 'react-router';
import { useT } from '../i18n/locale-context';

/**
 * «Resultados para «reforma» con los filtros activos · Buscar en todo el catálogo» — the
 * line over a keyword search that runs inside narrowing filters (`features.searchScopeLine`,
 * Spain). A word typed while a region, category or code is still on the page is searched
 * INSIDE them and nothing said so: «reforma» found 0 lots and «Obras» 1 on 21.10, in a
 * catalogue holding 271 and 2 578. At 0 results the empty card says it (`no-results-alert`);
 * this covers 1, 2, 15. `href` is the same page without the filters
 * (`hrefSearchWholeCatalogue`).
 */
export function SearchScopeLine({ q, href }: { q: string; href: string }) {
  const t = useT();
  return (
    <p
      data-testid="search-scope-line"
      className="mb-2 mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px] text-ink-soft"
    >
      <span className="font-semibold text-ink">{t('catalog.searchScope.label', { q })}</span>
      <Link to={href} className="font-semibold text-brand underline-offset-2 hover:underline">
        {t('catalog.searchScope.all')}
      </Link>
    </p>
  );
}
